import React from 'react';
import { FormBoolean } from 'adc-ui-components';
import { Field } from 'formik';
import get from 'lodash.get';

import BooleanField from './form-elements/BooleanField';
import DeviceCompareBlock from './DeviceCompareBlock';
import { joinClass } from '../helpers/component';

import Card from './Card';

const SwapOption = ({
  device,
}) => {
  const message = get(device, 'programs[0].messages[0]');

  return (
    <div className="swap-option">
      <div className="card-group">
        <div className="card-group__item">
          <Card>
            <FormBoolean
              label="Update this device"
              labelClass="heading3"
              inputId={`device_${device.serialNumber}`}
            >
              <Field
                id={`device_${device.serialNumber}`}
                type="checkbox"
                name="devices"
                value={device.serialNumber}
                component={BooleanField}
                disabled={device.eligibility === 'MANDATORY'}
              />
            </FormBoolean>
          </Card>
        </div>
        <div className="card-group__item">
          <Card className="card--secondary">
            {false && <pre>{JSON.stringify(device, null, 2)}</pre>}

            <DeviceCompareBlock className={joinClass(message && 'mb18')} device={device} />

            {message && (
              <div className="hgroup">
                <h5>Why do I need to update this device?</h5>
                <p>{message}</p>
              </div>
            )}
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SwapOption;
